<!-- Main view when user is logged in -->
<template>
  <v-app>
    <materialbank-nav-bar />

    <v-main class="ma-4">
      <router-view name="materialbank" />
    </v-main>
    <footer-bar />
  </v-app>
</template>
<script>
import MaterialbankNavBar from '@/components/Materiaalipankki/Menu/MaterialbankNavBar';
import FooterBar from '@/components/Materiaalipankki/Menu/Footer';

export default {
  components: {
    MaterialbankNavBar,
    FooterBar,
  },
  data() {
    return {
      username: '',
    };
  },
  async created() {
    // if (!this.$store.getters.isLoggedIn) {
    //  this.$router.push('/login');
    // }
    this.username = this.$store.getters.getUser.username;
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
  },
};
</script>
